var o = ":host,:root{--ngc-menu-dropdown-background-color: #fff;--ngc-menu-dropdown-max-width: 16rem}";
export { o as default };